import "./CTA.scss";
import {DiscordIcon, EmailIcon, InstagramIcon, TikTokIcon, YouTubeIcon} from "../../../../Images/Icon/Icon";
import {useTranslation} from "react-i18next";

type SocialItem = {
    name: string;
    description: string;
    href: string;
    icon: React.ReactNode;
};


const socials: SocialItem[] = [
    {
        name: "Discord",
        description: "Entra nel server ufficiale",
        href: "https://discord.gg/Xd4fEecuzm",
        icon: <DiscordIcon />,
    },
    {
        name: "TikTok",
        description: "Video e aggiornamenti",
        href: "https://www.tiktok.com/@enderclub.it",
        icon: <TikTokIcon />,
    },
    {
        name: "Instagram",
        description: "Foto e contenuti",
        href: "https://www.instagram.com/enderclub.it",
        icon: <InstagramIcon />,
    },
    {
        name: "YouTube",
        description: "Video e live",
        href: "https://youtube.com/@enderclubit",
        icon: <YouTubeIcon />,
    },
    {
        name: "Email",
        description: "Scrivici direttamente",
        href: "mailto:info@enderclub.it",
        icon: <EmailIcon />,
    },
];

export default function SocialCTA() {
    const { t } = useTranslation();
    return (
        <section className="social-cta" id="cta">
            <div className="social-cta__container">
                <header className="growth-services__header">
                    <h2>{t('home.CTA.title')}</h2>

                    <p>{t('home.CTA.subtitle')}</p>
                </header>

                <div className="social-cta__grid">
                    {socials.map((social) => (
                        <a
                            key={social.name}
                            href={social.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="social-card"
                        >
                            <div className="social-card__icon">
                                {social.icon}
                            </div>

                            <h3>{social.name}</h3>

                            <p>{t(`home.CTA.social.${social.name.toLowerCase()}`)}</p>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
